import { Command } from './Commands';

export class ChangePageMainNavigationVisibility extends Command {
	priority: number = 100;
	constructor(public value: string | string[], id: string) {
		super(value, id);
	}
	type: string = 'Page.ChangePageMainNavigationVisibility';
}